import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	accountLogo: {
		maxHeight: 70,
		backgroundColor: 'white',
		maxWidth: '60%',
		position: 'relative',
	},
	container: {
		height: 'auto',
		position: 'relative',
	},
	editButton: {
		fontSize: 11,
	},
	editLogoLabel: {
		display: 'inline-flex',
		alignItems: 'center',
	},
});
